export enum ReportTemplateType {
    WorkTimeReport = "WorkTimeReport",
}

export interface ReportTemplateDto {
    id: string;
    rowId: string;
    type: ReportTemplateType;
    name: string;
    json: ReportTemplateJson;
}

export interface ReportTemplateDeleteDto {
    rowId: string;
}

export interface ReportTemplateSaveDto {
    id?: string | null;
    rowId?: string | null;
    type: ReportTemplateType;
    name: string;
    json: string;
}

export interface SortModel {
    field: string;
    sort: "asc" | "desc";
}

export enum DisplayMode {
    Hours = "hours",
    Decimals = "decimals"
}

interface DisplayModeOptions
{
    mode: DisplayMode;
    decimals?: number;
}

export interface ReportTemplateJson {
    timeRange: [string, string];
    filters: Record<string, string[]>;
    selectedColumns: string[];
    columnOrder: string[];
    sortModel: SortModel[];
    grouping: string[];
    groupByRow: boolean;
    groupingModeMultiple: boolean;
    showGroupedRows: boolean;
    display: DisplayModeOptions;
    stopDurationThresholdMinutes?: number;
}
